import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

// import materialRoutes from "app/views/material-kit/MaterialRoutes";

// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLoginCPY = Loadable(lazy(() => import("app/views/sessions/JWTLogin_CPY")));
const JwtRegister = Loadable(lazy(() => import("app/views/sessions/JwtRegister")));
const ForgotPassword = Loadable(lazy(() => import("app/views/sessions/ForgotPassword")));
// E-CHART PAGE
const AppEchart = Loadable(lazy(() => import("app/views/charts/echarts/AppEchart")));
// DASHBOARD PAGE
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
//Users
const Users = Loadable(lazy(() => import("app/views/users/list")));
//Roles
const Roles = Loadable(lazy(() => import("app/views/roles/list")));
const AddRole = Loadable(lazy(() => import("app/views/roles/create")));
const EditRole = Loadable(lazy(() => import("app/views/roles/edit")));
// Categories
const Categories = Loadable(lazy(() => import("app/views/categories/list")));
const AddCategory = Loadable(lazy(() => import("app/views/categories/create")));
const EditCategory = Loadable(lazy(() => import("app/views/categories/edit")));
//Colors
const Colors = Loadable(lazy(() => import("app/views/colors/list")));
//brand
const Brands = Loadable(lazy(() => import("app/views/brands/list")));
const AddBrand = Loadable(lazy(() => import("app/views/brands/create")));
const EditBrand = Loadable(lazy(() => import("app/views/brands/edit")));

//car ads
const Cars = Loadable(lazy(() => import("app/views/cars/list")));
const AddCar = Loadable(lazy(() => import("app/views/cars/create")));
const EditCar = Loadable(lazy(() => import("app/views/cars/edit")));
const CarDetails = Loadable(lazy(() => import("app/views/cars/details")));

//offers
const Offers = Loadable(lazy(() => import("app/views/offers/list")));
//Countries
const Countries = Loadable(lazy(() => import("app/views/countries/list")));
const AddCountries = Loadable(lazy(() => import("app/views/countries/create")));
const EditCountry = Loadable(lazy(() => import("app/views/countries/edit")));
//plans
const Packages = Loadable(lazy(() => import("app/views/packages/list")));
const AddPackage = Loadable(lazy(() => import("app/views/packages/create")));
const EditPackage = Loadable(lazy(() => import("app/views/packages/edit")));
//banners
const Banners = Loadable(lazy(() => import("app/views/banners/list")));
const AddBanner = Loadable(lazy(() => import("app/views/banners/create")));
const EditBanner = Loadable(lazy(() => import("app/views/banners/edit")));
//faqs
const Faqs = Loadable(lazy(() => import("app/views/faqs/list")));
const AddFaq = Loadable(lazy(() => import("app/views/faqs/create")));
const EditFaq = Loadable(lazy(() => import("app/views/faqs/edit")));
//Subscriptions
const Subscriptions = Loadable(lazy(() => import("app/views/subscriptions/list")));
//Adverts
const Ads = Loadable(lazy(() => import("app/views/ads/list")));
//contact
const Subjects = Loadable(lazy(() => import("app/views/contactus/subject")));
const AddSubject = Loadable(lazy(() => import("app/views/contactus/addSubject")));
const EditSubject = Loadable(lazy(() => import("app/views/contactus/editSubject")));
//contact details
const Details = Loadable(lazy(() => import("app/views/details/AdminDetails")));
//customer Queries
const Queries = Loadable(lazy(() => import("app/views/queries/list")));
//notifications
const Notifications = Loadable(lazy(() => import("app/views/notifications/list")));
const AddNotification = Loadable(lazy(() => import("app/views/notifications/create")));
//Privacy Policy
const PrivacyPolicy = Loadable(lazy(() => import("app/views/policy/policy")));
const UpdatePolicy = Loadable(lazy(() => import("app/views/policy/update-policy")));
//Terms And Conditions
const TermsAndConditions = Loadable(lazy(() => import("app/views/terms-and-conditions/T&C")));
const UpdateTermsAndConditions = Loadable(
  lazy(() => import("app/views/terms-and-conditions/update"))
);
//guest
const GuestPolicy = Loadable(lazy(() => import("app/views/guest/privacy-policy")));
const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      //...materialRoutes,
      // dashboard route
      { path: "/dashboard/analytics", element: <Analytics />, auth: authRoles.admin },
      //Users
      { path: "dashboard/users/", element: <Users />, auth: authRoles.admin },
      //Roles
      { path: "dashboard/roles/", element: <Roles />, auth: authRoles.admin },
      { path: "dashboard/roles/create", element: <AddRole />, auth: authRoles.admin },
      { path: "dashboard/roles/edit/:id", element: <EditRole />, auth: authRoles.admin },
      //categories
      { path: "dashboard/categories/", element: <Categories />, auth: authRoles.admin },
      { path: "dashboard/categories/create", element: <AddCategory />, auth: authRoles.admin },
      { path: "dashboard/categories/edit/:id", element: <EditCategory />, auth: authRoles.admin },
      //Colors
      { path: "dashboard/colors/", element: <Colors />, auth: authRoles.admin },
      //brands
      { path: "dashboard/brands/", element: <Brands />, auth: authRoles.admin },
      { path: "dashboard/brands/create", element: <AddBrand />, auth: authRoles.admin },
      { path: "dashboard/brands/edit/:id", element: <EditBrand />, auth: authRoles.admin },
      //car ads
      { path: "dashboard/car-ads/", element: <Cars />, auth: authRoles.admin },
      { path: "dashboard/car-ads/create", element: <AddCar />, auth: authRoles.admin },
      { path: "dashboard/car-ads/:id/edit", element: <EditCar />, auth: authRoles.admin },
      { path: "dashboard/car-ads/:id/details", element: <CarDetails />, auth: authRoles.admin },
      //offers
      { path: "dashboard/offers/", element: <Offers />, auth: authRoles.admin },
      //brands
      { path: "dashboard/countries/", element: <Countries />, auth: authRoles.admin },
      { path: "dashboard/countries/create", element: <AddCountries />, auth: authRoles.admin },
      { path: "dashboard/countries/edit/:id", element: <EditCountry />, auth: authRoles.admin },
      //plans
      { path: "dashboard/plans/", element: <Packages />, auth: authRoles.admin },
      { path: "dashboard/plans/create", element: <AddPackage />, auth: authRoles.admin },
      { path: "dashboard/plans/edit/:id", element: <EditPackage />, auth: authRoles.admin },
      //Banners
      { path: "dashboard/banners/", element: <Banners />, auth: authRoles.admin },
      { path: "dashboard/banners/create", element: <AddBanner />, auth: authRoles.admin },
      { path: "dashboard/banners/edit/:id", element: <EditBanner />, auth: authRoles.admin },
      //Faqs
      { path: "dashboard/faqs/", element: <Faqs />, auth: authRoles.admin },
      { path: "dashboard/faqs/create", element: <AddFaq />, auth: authRoles.admin },
      { path: "dashboard/faqs/edit/:id", element: <EditFaq />, auth: authRoles.admin },
      //featured car ads
      { path: "dashboard/featured-car-ads/", element: <Ads />, auth: authRoles.admin },
      //Contact Us
      { path: "dashboard/contactus/subject", element: <Subjects />, auth: authRoles.admin },
      { path: "dashboard/contactus/addSubject", element: <AddSubject />, auth: authRoles.admin },
      {
        path: "dashboard/contactus/editSubject/:id",
        element: <EditSubject />,
        auth: authRoles.admin
      },
      //Queries
      { path: "dashboard/queries", element: <Queries /> },
      //privacy policy routes
      { path: "dashboard/privacy-policy", element: <PrivacyPolicy />, auth: authRoles.admin },
      { path: "dashboard/privacy-policy/edit", element: <UpdatePolicy />, auth: authRoles.admin },
      // Terms & Conditions routes
      {
        path: "dashboard/terms-and-conditions",
        element: <TermsAndConditions />,
        auth: authRoles.admin
      },
      {
        path: "dashboard/terms-and-conditions/edit",
        element: <UpdateTermsAndConditions />,
        auth: authRoles.admin
      },

      //Admin Details
      { path: "dashboard/contact/details", element: <Details />, auth: authRoles.admin },
      //Notifications
      { path: "dashboard/notifications/", element: <Notifications />, auth: authRoles.admin },
      {
        path: "dashboard/notifications/create",
        element: <AddNotification />,
        auth: authRoles.admin
      },
      //subscriptions
      { path: "dashboard/subscriptions/", element: <Subscriptions />, auth: authRoles.admin },
      // e-chart route
      { path: "/charts/echarts", element: <AppEchart />, auth: authRoles.editor }
    ]
  },

  // session pages route
  { path: "/session/404", element: <NotFound /> },
  { path: "/session/signin", element: <JwtLoginCPY /> },
  { path: "/session/signup", element: <JwtRegister /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  //guest routes
  { path: "/privacy-policy", element: <GuestPolicy /> },
  { path: "/", element: <Navigate to="dashboard/analytics" /> },
  { path: "*", element: <NotFound /> }
];

export default routes;
